import ApiService from './api.service';

class GlobalConfigService {
  async list() {
    try {
      const response = await ApiService.get('/global-config');
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async update(configData) {
    try {
      const response = await ApiService.put(`/global-config/update`, configData);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  async statistics(startDate = null, endDate = null) {
    try {
      let url = '/statistics';
      if (startDate && endDate) {
        url += `?start_date=${startDate}&end_date=${endDate}`;
      }
      const response = await ApiService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  }
}

export default new GlobalConfigService();